import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiLinkedin, FiFacebook, FiTwitter } from 'react-icons/fi';
import { BsWhatsapp } from 'react-icons/bs';
import logo from '../assets/vpchemtechlogo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-vp-grey-700 border-t-2 border-vp-grey-200">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-8 lg:py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-2">
            <div className="relative flex items-center mb-4">
              <img
                src={logo}
                alt="VP Chem Technologies"
                className="pointer-events-none select-none absolute -left-24 top-1/2 -translate-y-1/2 h-56 md:h-72 lg:h-96 w-auto object-contain transition-all duration-300 origin-left scale-125 md:scale-150 lg:scale-150"
              />
              {/* Invisible box to reserve space */}
              <div className="h-20 md:h-24 lg:h-28 w-36 md:w-44 lg:w-52"></div>
            </div>
            <p className="text-sm leading-relaxed">
              Leading provider of sustainable, biodegradable water base solution
              for industrial excellence and environmental protection.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-vp-grey-200 text-vp-grey-700 flex items-center justify-center hover:bg-vp-green-600 hover:text-white transition-colors duration-300"
              >
                <FiLinkedin size={18} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-vp-grey-200 text-vp-grey-700 flex items-center justify-center hover:bg-vp-green-600 hover:text-white transition-colors duration-300"
              >
                <FiFacebook size={18} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-vp-grey-200 text-vp-grey-700 flex items-center justify-center hover:bg-vp-green-600 hover:text-white transition-colors duration-300"
              >
                <FiTwitter size={18} />
              </a>
              <a
                href="https://wa.me/1234567890"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-vp-grey-200 text-vp-grey-700 flex items-center justify-center hover:bg-vp-green-600 hover:text-white transition-colors duration-300"
              >
                <BsWhatsapp size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-vp-grey-900 font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Our Products
                </Link>
              </li>
              <li>
                <Link
                  to="/industries"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Industries
                </Link>
              </li>
              <li>
                <Link
                  to="/success"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Our Success
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-vp-grey-900 font-semibold text-lg mb-4">Our Products</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/products/ru-dsa-6"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  RU DSA-6
                </Link>
              </li>
              <li>
                <Link
                  to="/products/ru-ora-7"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  RU ORA-7
                </Link>
              </li>
              <li>
                <Link
                  to="/products/v-mukti-24"
                  className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300 text-sm"
                >
                  V-MUKTI 24
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-vp-grey-900 font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <FiMapPin className="text-vp-green-600 mt-1 flex-shrink-0" size={18} />
                <span className="text-sm">
                  VP Chem Technologies LLP<br />
                  Plot No. 12, Arun Kunj, Bajaj Nagar,<br />
                  Nagpur, Maharashtra (INDIA)
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FiPhone className="text-vp-green-600 flex-shrink-0" size={18} />
                <a
                  href="tel:+919371640163"
                  className="text-sm text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300"
                >
                  Sanjay Vyas +91 9371640163
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <FiMail className="text-vp-green-600 flex-shrink-0" size={18} />
                <a
                  href="mailto:vpchemtechnologies19@gmail.com"
                  className="text-sm text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300"
                >
                  vpchemtechnologies19@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-vp-grey-200">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-vp-grey-600">
              © {currentYear} VP Chem Technologies LLP. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link
                to="/privacy-policy"
                className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-conditions"
                className="text-vp-grey-600 hover:text-vp-green-600 transition-colors duration-300"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
